import Styles from "./Doc.module.css"
function Doc3ui(){
    return(
        <>
           <div className={Styles.p3div1}>
            <p>hello</p>
           </div>
        </>
    );
}
export default Doc3ui;